function doProdCarousel() {
  if (customElements.get("prod-carousel")) return null;

  class ProdCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector(".prod-carousel-slider");
      this.init();
    }
    init() {
      this.executeSwiper();
    }

    executeSwiper() {
      if (this.sliderElement == null) return;
      const swiper = new Swiper(this.sliderElement, {
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: ".prod-carousel-next",
          prevEl: ".prod-carousel-prev",
        },
        breakpoints: {
          989: {
            spaceBetween: 20,
            slidesPerView: 4,
            slidesPerView: "auto",
          },
        },
      });
    }
  }
  customElements.define("prod-carousel", ProdCarousel);
}
doProdCarousel();
